import {sprintf} from "sprintf-js";
import React from "react";
import {Card, CardContent, Grid, Typography} from "@mui/material";
import {ChecklistField, LeadChecklistField} from "../formFields/ChecklistField";
import ChecklistItemDefault from "../defaults/ChecklistItemDefault";

const [section, relPath, title] = [1, "LivingRoom", "Living Room"];

const LivingRoomDefaults = () => {
    return {
        "1": {
            "1": ChecklistItemDefault,
            "2": ChecklistItemDefault,
            "3": ChecklistItemDefault,
            "4": ChecklistItemDefault,
            "5": ChecklistItemDefault,
            "6": ChecklistItemDefault,
            "7": ChecklistItemDefault,
            "8": ChecklistItemDefault,
            "9": ChecklistItemDefault,
        }
    };
};

const LivingRoom = () => {
    return (
        <>
            <Card>
                <CardContent>
                    <Typography variant={"h6"} gutterBottom>
                        {sprintf("%d. %s", section, title)}
                    </Typography>
                    <Grid container spacing={3}>
                        <ChecklistField
                            path={sprintf("%s.%s", relPath, "present")}
                            rank={"1.1"}
                            room={title}
                            desc={"Living Room Present"}
                            section={section}
                        />
                    </Grid>
                    <Grid container spacing={3}>
                        <ChecklistField
                            path={sprintf("%s.%s", relPath, "electricity")}
                            rank={"1.2"}
                            room={title}
                            desc={"Electricity"}
                            section={section}
                        />
                    </Grid>
                    <Grid container spacing={3}>
                        <ChecklistField
                            path={sprintf("%s.%s", relPath, "electricalHazard")}
                            rank={"1.3"}
                            room={title}
                            desc={"Free of Electrical Hazards"}
                            section={section}
                        />
                    </Grid>
                    <Grid container spacing={3}>
                        <ChecklistField
                            path={sprintf("%s.%s", relPath, "security")}
                            rank={"1.4"}
                            room={title}
                            desc={"Security"}
                            section={section}
                        />
                    </Grid>
                    <Grid container spacing={3}>
                        <ChecklistField
                            path={sprintf("%s.%s", relPath, "windowCondition")}
                            rank={"1.5"}
                            room={title}
                            desc={"Window Condition"}
                            section={section}
                        />
                    </Grid>
                    <Grid container spacing={3}>
                        <ChecklistField
                            path={sprintf("%s.%s", relPath, "ceilingCondition")}
                            rank={"1.6"}
                            room={title}
                            desc={"Ceiling Condition"}
                            section={section}
                        />
                    </Grid>
                    <Grid container spacing={3}>
                        <ChecklistField
                            path={sprintf("%s.%s", relPath, "wallCondition")}
                            rank={"1.7"}
                            room={title}
                            desc={"Wall Condition"}
                            section={section}
                        />
                    </Grid>
                    <Grid container spacing={3}>
                        <ChecklistField
                            path={sprintf("%s.%s", relPath, "floorCondition")}
                            rank={"1.8"}
                            room={title}
                            desc={"Floor Condition"}
                            section={section}
                        />
                    </Grid>
                    <Grid container spacing={3}>
                        <LeadChecklistField
                            path={sprintf("%s.%s", relPath, "leadPaint")}
                            rank={"1.9"}
                            room={title}
                            desc={"Lead-Based Paint"}
                            section={section}
                        />
                    </Grid>

                </CardContent>
            </Card>
        </>
    );
};

export default LivingRoom;
export {LivingRoomDefaults};